import { render, staticRenderFns } from "./PollsResultsStandaloneDonut.vue?vue&type=template&id=42965af5&"
import script from "./PollsResultsStandaloneDonut.vue?vue&type=script&lang=js&"
export * from "./PollsResultsStandaloneDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports